import React from "react";
import { connect } from "react-redux";
import PortletSpinner from '../../partials/layout/PortletSpinner';
import { Render } from "@measured/puck";
import { getPuckDashboardRenderer } from "../admin/Templates/MasterTemplates/MasterTemplateDashboardDesigner";
import { FormattedMessage, injectIntl } from "react-intl";
import DefaultDashboardDesign from "../../Templates/DefaultDashboardDesign";


class Dashboard2 extends React.Component {

  constructor(props) {
    super(props);
    this.config = getPuckDashboardRenderer(props);
    this.dashboardDesign = props.contractTemplate.dashboardDesign || DefaultDashboardDesign;

  }

  render() {
    if (!this.props.contractDashboard || !this.props.contractTemplate || !this.props.contractUsers) {
      return (<PortletSpinner />);
    }
    const { contract } = this.props;

    return (
      <Render key={"DynamicDashboard" + this.props.dashboardCurrencyCode} config={this.config} data={this.dashboardDesign} />
    );
  }
}

const mapStateToProps = store => ({
  contract: store.contract.contract,
  contractTemplate: store.contract.template,
  contractDashboard: store.contract.dashboard,
  dashboardCurrencyCode: store.contract.dashboardCurrencyCode,
  userProfile: store.auth.userProfile,
  contractUsers: store.contract.users,
  actions: store.contract.manualActions,
  lang: store.i18n.lang,
});

export default injectIntl(connect(mapStateToProps)(Dashboard2));